export default {
    getSiteGroupTypesList: state => {
        return state.siteGroupTypesList;
    },
    getSelectedSiteGroupTypesObjects: state => {
        return state.filteredSiteGroupTypesObjects;
    },
    getSelectedSiteGroupTypesList: state => {
        return state.selectedSiteGroupTypesList;
    },

    getNetworkList: state => {
        return state.networkList;
    },
    getSelectedNetworkObjects: state => {
        return state.filteredNetworkObjects;
    },
    getSelectedNetworkList: state => {
        return state.selectedNetworkList;
    },

    getCustomReportFilters: state => {
        return {
            siteGroupTypes: state.selectedSiteGroupTypesList,
            networks: state.selectedNetworkList
        };
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/hourlyPartnersReport/getters.js